import React from "react";

// Self-hosted brand logo. We bundle it under /public/brand/jante-logo.png so
// the image lives on the same origin as the app — fixes intermittent mobile
// failures we'd see when loading from the Emergent customer-assets CDN
// (some mobile carriers + ad blockers refuse third-party image domains, and
// PWAs need same-origin assets for offline caching anyway).
export const LOGO_URL = "/brand/jante-logo.png";

export default function BrandLogo({ className = "h-10", showWordmark = true }) {
  return (
    <img
      src={LOGO_URL}
      alt="Janté Travel Concierges"
      className={`${className} object-contain`}
      style={{ width: "auto" }}
      loading="eager"
      fetchPriority="high"
      data-testid="brand-logo"
    />
  );
}
